import { CACHE_TIMES } from '@/config/cache';
import type { SelectedNetwork } from '@/types';
import { usePayoutCampaignsQuery } from '@/services/revenueApi';

/**
 * This hook is used to fetch the payouts campaign data.
 * @param selectedNetwork - The selected network.
 * @param year - The year.
 * @param month - The month.
 * @param enabled - Whether the query is enabled.
 * @returns The campaign data.
 */
const usePayoutsCampaignData = (
  selectedNetwork: SelectedNetwork | undefined,
  year: string | undefined,
  month: string | undefined,
  enabled: boolean
) => {
  return usePayoutCampaignsQuery(selectedNetwork?.id ?? '', year ?? '', month ?? '', {
    enabled,
    refetchOnMount: false,
    staleTime: CACHE_TIMES.SHORT,
  });
};

export default usePayoutsCampaignData;
